import React, { Component } from "react";
import axios from "axios";
import CommunityLayout from "./layouts/CommunityLayout";
import { Grid, Row, Cell, Icon } from "../../_foundation/foundation";
//import { Link } from "react-router-dom";
//import { Icon } from "../_foundation/_buttons";
import withContext from "../../../context/contextHOC";
import ClassicForumLayout from "./layouts/thread/ClassicForumLayout";
import CommunityBackButton from "./CommunityBackButton";
import MMPopup from "../../mmcomponents/mmpopup/MMPopup";

class CommunityThread extends Component {
  state = {
    boardSlug: this.props.match.params.boardSlug,
    threadSlug: this.props.match.params.threadSlug,
    board: null,
    thread: null,
    status: "INIT",
    breadcrumbs: ["home", "communityAreas"],
    showThreadNamePopup: false,
    threadName: "",
  };

  componentDidMount() {
    const _c = this.props.context;
    _c.showLoadingScreen();
    _c.setLoadedModule("community");
    this.init();
  }

  render() {
    const { breadcrumbs } = this.state;
    const _c = this.props.context;

    let layout = _c.setting("community_main_layout");
    if (!layout) {
      layout = "layout1";
    }

    let v__content = (
      <div className={`community-${layout}`}>
        <CommunityLayout
          view="thread"
          layout={layout}
          breadcrumbs={breadcrumbs}
          user={_c.getUser()}
          help="communityThread"
        >
          {this.view__showContent()}
          {this.view__showPopup()}
        </CommunityLayout>
      </div>
    );

    return <div className="community-thread">{v__content}</div>;
  }

  view__showContent() {
    const { status } = this.state;
    const _c = this.props.context;

    if (status === "LOADED") {
      return (
        <React.Fragment>
          {this.view__showTitle()}
          {this.view__showThread()}
        </React.Fragment>
      );
    } else {
      return _c.loading();
    }
  }

  view__showPopup() {
    const { showThreadNamePopup, threadName } = this.state;
    const _c = this.props.context;

    if (showThreadNamePopup === true) {
      return (
        <MMPopup
          size="small"
          handleClose={() => {
            this.setState({ showThreadNamePopup: false });
          }}
          show={true}
        >
          <h3>{_c.translate("community.moderator.thread.name.popup.title")}</h3>
          <Grid type="full">
            <Row margin="xy">
              <Cell sm={24} md={16}>
                <input
                  type="text"
                  value={threadName}
                  placeholder={_c.translate(
                    "community.moderator.thread.name.popup.placeholder"
                  )}
                  onChange={(e) => {
                    this.setState({ threadName: e.target.value });
                  }}
                />
              </Cell>
              <Cell sm={24} md={8}>
                <button
                  className="small primary button"
                  style={{ width: "100%" }}
                  onClick={this.handle__editThreadName}
                >
                  <Icon icon="check" left /> {_c.translate("buttons.save")}
                </button>
              </Cell>
            </Row>
          </Grid>
        </MMPopup>
      );
    }
  }

  view__showTitle() {
    const { board, thread, status } = this.state;
    const _c = this.props.context;

    if (status === "LOADED") {
      let v__editThreadName;
      if (_c.isCommunityModerator()) {
        v__editThreadName = (
          <span>
            |{" "}
            <button
              onClick={() => {
                this.setState({
                  showThreadNamePopup: true,
                  threadName: thread.name,
                });
              }}
              className="community-thread-name-button"
            >
              {_c.translate("community.moderator.thread.name.button")}
            </button>
          </span>
        );
      }

      let v__threadAuthor;
      if (thread.author) {
        v__threadAuthor = (
          <div className="thread-author">
            {_c.translate("community.thread.by")} {thread.author.displayname}{" "}
            {v__editThreadName}
          </div>
        );
      }

      let v__backButton = (
        <CommunityBackButton
          url={_c
            .config("urls.communityBoard")
            .replace(":boardSlug", board.slug)}
          text={_c.translate("community.thread.backToBoard", {
            boardName: board.name,
          })}
        />
      );

      let v__stickyButton;
      if (_c.isCommunityModerator()) {
        if (thread.sticky === true) {
          v__stickyButton = (
            <button
              className="small hollow primary button"
              onClick={this.handle__stickyThread}
              data-tip={_c.translate(
                "community.moderator.thread.sticky.buttons.unsticky.tooltip"
              )}
            >
              <Icon icon="thumb-tack" left />{" "}
              {_c.translate(
                "community.moderator.thread.sticky.buttons.unsticky.label"
              )}
            </button>
          );
        } else {
          v__stickyButton = (
            <button
              className="small primary button"
              onClick={this.handle__stickyThread}
              data-tip={_c.translate(
                "community.moderator.thread.sticky.buttons.sticky.tooltip"
              )}
            >
              <Icon icon="thumb-tack" left />{" "}
              {_c.translate(
                "community.moderator.thread.sticky.buttons.sticky.label"
              )}
            </button>
          );
        }
      }

      let v__deleteButton;
      if (_c.isCommunityModerator()) {
        v__deleteButton = (
          <button
            className="small primary button"
            onClick={this.handle__deleteThread}
          >
            <Icon icon="trash" left />{" "}
            {_c.translate("community.moderator.thread.delete.button")}
          </button>
        );
      }

      let v__lockButton;
      if (_c.isCommunityModerator()) {
        if (thread.locked === true) {
          v__lockButton = (
            <button
              className="small primary button"
              onClick={this.handle__unlockThread}
            >
              <Icon icon="unlock" left />{" "}
              {_c.translate("community.moderator.thread.unlock.button")}
            </button>
          );
        } else {
          v__lockButton = (
            <button
              className="small primary button"
              onClick={this.handle__lockThread}
            >
              <Icon icon="lock" left />{" "}
              {_c.translate("community.moderator.thread.lock.button")}
            </button>
          );
        }
      }

      let v__sticky;
      if (thread.sticky === true) {
        v__sticky = (
          <span className="red-badge">
            {_c.translate("community.moderator.thread.sticky.sticky")}
          </span>
        );
      }

      return (
        <div className="community-header">
          <Grid type="full">
            <Row>
              <Cell sm={24} md={12}>
                {v__backButton}
                <h1>
                  {thread.name} {v__sticky}
                </h1>
                {v__threadAuthor}
              </Cell>
              <Cell sm={24} md={12} className="text-right">
                <div className="community-header-buttons">
                  {v__stickyButton}&nbsp;&nbsp;
                  {v__deleteButton}&nbsp;&nbsp;
                  {v__lockButton}
                </div>
              </Cell>
            </Row>
          </Grid>
        </div>
      );
    }
  }

  view__showThread() {
    const { thread } = this.state;
    const _c = this.props.context;

    if (!thread || !thread.posts) {
      return;
    }

    let threadLayout = _c.setting("community_thread_layout");
    if (!threadLayout) {
      threadLayout = "classic_forum";
    }

    let v__content;

    if (threadLayout === "classic_forum") {
      v__content = (
        <ClassicForumLayout
          thread={thread}
          onUpdate={(thread) => {
            this.setState({ thread });
          }}
          onPostLike={(post, type) => {
            this.handle__likePost(post, type);
          }}
          onDeletePost={(postId) => {
            this.handle__deletePost(postId);
          }}
          onCreateBlockQuote={(post) => {
            return this.handle__createBlockQuote(post);
          }}
        />
      );
    }

    return <React.Fragment>{v__content}</React.Fragment>;
  }

  handle__createBlockQuote = (post) => {
    const _c = this.props.context;
    let blockQuoteHtml;

    let v__quote = _c.translate("community.reply.quote.info");
    v__quote = v__quote
      .replace("{date}", post.created_at_f)
      .replace("{name}", post.author.displayname);

    blockQuoteHtml = `<p>${v__quote}</p><blockquote><p>${post.text_html}</p></blockquote>`;

    return blockQuoteHtml;
  };

  handle__likePost(post, type) {
    const _c = this.props.context;

    post.like_loading = true;
    this.setState({ post });

    let apiUrl = _c.apiUrl("community.likePost", {
      postId: post.id,
    });

    axios
      .patch(
        apiUrl,
        { type: type },
        {
          headers: _c.getHeaders(),
        }
      )
      .then((response) => {
        try {
          if (_c.isDebug()) {
            console.log("API RESPONSE", response.data);
          }

          const { status } = response.data;
          _c.handleApiResponse(response.data, true);

          if (status === "SUCCESS") {
            const communityData = response.data.data;
            const { thread } = communityData;

            this.setState({ thread });
          }
        } catch {
          return _c.handleError(
            { status: "AXIOS_RESPONSE_ERROR" },
            "community:post:like:response"
          );
        }
      })
      .catch((error) => {
        return _c.handleError(error, "community:post:like");
      });
  }

  handle__deletePost = (postId) => {
    const _c = this.props.context;

    if (window.confirm(_c.translate("community.post.deletePopup.message"))) {
      let apiUrl = _c.apiUrl("community.post", {
        postId: postId,
      });

      axios
        .delete(apiUrl, {
          headers: _c.getHeaders(),
        })
        .then((response) => {
          try {
            if (_c.isDebug()) {
              console.log("API RESPONSE", response.data);
            }

            const { status } = response.data;

            if (status === "SUCCESS") {
              const communityData = response.data.data;
              const { thread } = communityData;

              if (thread) {
                this.setState({ thread });
                _c.createNotifictation(
                  _c.translate("community.post.deletePopup.notification.title"),
                  _c.translate(
                    "community.post.deletePopup.notification.message"
                  ),
                  "success"
                );
              } else {
                return _c.handleError(
                  { status: "AXIOS_RESPONSE_ERROR" },
                  "community:post:delete:empty"
                );
              }
            }
          } catch (error) {
            return _c.handleError(
              { status: "AXIOS_RESPONSE_ERROR" },
              "community:post:delete:response"
            );
          }
        })
        .catch((error) => {
          return _c.handleError(error, "community:post:delete");
        });
    }
  };

  handle__unlockThread = () => {
    const { thread } = this.state;

    const _c = this.props.context;

    if (
      window.confirm(_c.translate("community.moderator.thread.unlock.confirm"))
    ) {
      let apiUrl = _c.apiUrl("community.moderator.thread.unlock", {
        thread: thread.id,
      });

      axios
        .get(apiUrl, {
          headers: _c.getHeaders(),
        })
        .then((response) => {
          try {
            if (_c.isDebug()) {
              console.log("API RESPONSE", response.data);
            }

            const { status } = response.data;
            _c.handleApiResponse(response.data, true);

            if (status === "SUCCESS") {
              const communityData = response.data.data;
              const { board, thread } = communityData;
              this.setState({ board, thread }, () => {
                _c.createNotifictation(
                  _c.translate("community.moderator.thread.unlock.saved.title"),
                  _c.translate("community.moderator.thread.unlock.saved.text"),
                  "success"
                );
              });
            }
          } catch {
            return _c.handleError(
              { status: "AXIOS RESPONSE ERROR" },
              "community:moderator:thread:unlock:response"
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            return _c.handleError(error, "community:moderator:thread:unlock");
          }
        });
    }
  };

  handle__lockThread = () => {
    const { thread } = this.state;

    const _c = this.props.context;

    if (
      window.confirm(_c.translate("community.moderator.thread.lock.confirm"))
    ) {
      let apiUrl = _c.apiUrl("community.moderator.thread.lock", {
        thread: thread.id,
      });

      axios
        .get(apiUrl, {
          headers: _c.getHeaders(),
        })
        .then((response) => {
          try {
            if (_c.isDebug()) {
              console.log("API RESPONSE", response.data);
            }

            const { status } = response.data;
            _c.handleApiResponse(response.data, true);

            if (status === "SUCCESS") {
              const communityData = response.data.data;
              const { board, thread } = communityData;
              this.setState({ board, thread }, () => {
                _c.createNotifictation(
                  _c.translate("community.moderator.thread.lock.saved.title"),
                  _c.translate("community.moderator.thread.lock.saved.text"),
                  "success"
                );
              });
            }
          } catch {
            return _c.handleError(
              { status: "AXIOS RESPONSE ERROR" },
              "community:moderator:thread:lock:response"
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            return _c.handleError(error, "community:moderator:thread:lock");
          }
        });
    }
  };

  handle__stickyThread = () => {
    const { thread } = this.state;

    const _c = this.props.context;

    let apiUrl = _c.apiUrl("community.moderator.thread.sticky", {
      thread: thread.id,
    });

    axios
      .get(apiUrl, {
        headers: _c.getHeaders(),
      })
      .then((response) => {
        try {
          if (_c.isDebug()) {
            console.log("API RESPONSE", response.data);
          }

          const { status } = response.data;
          _c.handleApiResponse(response.data, true);

          if (status === "SUCCESS") {
            const communityData = response.data.data;
            const { board, thread } = communityData;
            this.setState({ board, thread }, () => {
              if (thread.sticky === true) {
                _c.createNotifictation(
                  _c.translate(
                    "community.moderator.thread.sticky.buttons.sticky.saved.title"
                  ),
                  _c.translate(
                    "community.moderator.thread.sticky.buttons.sticky.saved.text"
                  ),
                  "success"
                );
              } else {
                _c.createNotifictation(
                  _c.translate(
                    "community.moderator.thread.sticky.buttons.unsticky.saved.title"
                  ),
                  _c.translate(
                    "community.moderator.thread.sticky.buttons.unsticky.saved.text"
                  ),
                  "success"
                );
              }
            });
          }
        } catch {
          return _c.handleError(
            { status: "AXIOS RESPONSE ERROR" },
            "community:moderator:thread:unlock:response"
          );
        }
      })
      .catch((error) => {
        if (error.response) {
          return _c.handleError(error, "community:moderator:thread:unlock");
        }
      });
  };

  handle__editThreadName = () => {
    const { thread, threadName } = this.state;

    const _c = this.props.context;

    let apiUrl = _c.apiUrl("community.moderator.thread.name", {
      thread: thread.id,
    });

    axios
      .patch(
        apiUrl,
        {
          threadName: threadName,
        },
        {
          headers: _c.getHeaders(),
        }
      )
      .then((response) => {
        try {
          if (_c.isDebug()) {
            console.log("API RESPONSE", response.data);
          }

          const { status } = response.data;
          _c.handleApiResponse(response.data, true);

          if (status === "SUCCESS") {
            const communityData = response.data.data;
            const { board, thread } = communityData;
            this.setState(
              { board, thread, threadName: "", showThreadNamePopup: false },
              () => {
                _c.createNotifictation(
                  _c.translate("community.moderator.thread.name.saved.title"),
                  _c.translate("community.moderator.thread.name.saved.text"),
                  "success"
                );
              }
            );
          }
        } catch {
          return _c.handleError(
            { status: "AXIOS RESPONSE ERROR" },
            "community:moderator:thread:unlock:response"
          );
        }
      })
      .catch((error) => {
        if (error.response) {
          return _c.handleError(error, "community:moderator:thread:unlock");
        }
      });
  };

  handle__deleteThread = () => {
    const { thread, boardSlug } = this.state;

    const _c = this.props.context;

    if (
      window.confirm(_c.translate("community.moderator.thread.delete.confirm"))
    ) {
      let apiUrl = _c.apiUrl("community.moderator.thread.delete", {
        thread: thread.id,
      });

      axios
        .get(apiUrl, {
          headers: _c.getHeaders(),
        })
        .then((response) => {
          try {
            if (_c.isDebug()) {
              console.log("API RESPONSE", response.data);
            }

            const { status } = response.data;
            _c.handleApiResponse(response.data, true);

            if (status === "SUCCESS") {
              window.location.href = _c
                .config("urls.communityBoard")
                .replace(":boardSlug", boardSlug);
            }
          } catch {
            return _c.handleError(
              { status: "AXIOS RESPONSE ERROR" },
              "community:moderator:thread:delete:response"
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            return _c.handleError(error, "community:moderator:thread:delete");
          }
        });
    }
  };

  init() {
    const { boardSlug, threadSlug } = this.state;
    const _c = this.props.context;

    let apiUrl = _c.apiUrl("community.thread", {
      boardSlug,
      threadSlug,
    });

    axios
      .get(apiUrl, {
        headers: _c.getHeaders(),
      })
      .then((response) => {
        try {
          if (_c.isDebug()) {
            console.log("API RESPONSE", response.data);
          }

          const { status } = response.data;
          _c.handleApiResponse(response.data, true);

          if (status === "SUCCESS") {
            const communityData = response.data.data;
            const { board, thread } = communityData;

            if (!board || !thread) {
              _c.permissionDenied();
              return;
            }

            const newBreadcrumb1 = {
              to: _c
                .config("urls.communityBoard")
                .replace(":boardSlug", board.slug),
              id: "communityBoard",
              name: board.name,
            };

            const newBreadcrumb2 = {
              to: "/",
              id: "communityThread",
              name: thread.name,
            };

            _c.setPageTitle(thread.name, true);

            let { breadcrumbs } = this.state;
            breadcrumbs.push(newBreadcrumb1);
            breadcrumbs.push(newBreadcrumb2);

            this.setState({
              thread,
              board,
              status: "LOADED",
              breadcrumbs,
            });
          }
        } catch {
          return _c.handleError(
            { status: "AXIOS_RESPONSE_ERROR" },
            "community:thread:init:response"
          );
        }
      })
      .catch((error) => {
        return _c.handleError(error, "community:thread:init");
      });
  }
}

export default withContext(CommunityThread);
